import React, { FC } from "react";
import { Control } from "react-hook-form";

import RadioBase, { RadioBaseProps } from "@/components/ui/Form/Filters/components/Radio/RadioBase";
import RadioControlled from "@/components/ui/Form/Filters/components/Radio/RadioControlled";

export interface RadioProps extends RadioBaseProps {
  control?: Control<any>;
}
const Radio: FC<RadioProps> = (args) => {
  return <>{args?.control ? <RadioControlled control={args.control} {...args} /> : <RadioBase {...args} />}</>;
};
export default Radio;
